import { format } from 'date-fns/format'

import { dateFormat } from '../../../constants/dateFormat'

export const formatDateISO = (date: Date) => format(date, dateFormat.dateISO)
